var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"back-to-top",on:{"click":_vm.scrollToTop}},[_c('BackToTopArrow',{ref:"icon",staticClass:"back-to-top__icon"}),_c('div',{staticClass:"back-to-top__label"},[_vm._v(" "+_vm._s(_vm.$config.common.scrollTop)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }